import { useContext } from 'react';
import MetricsContext, { MetricsCtxType } from './metrics-context';

export default function useMetrics(): MetricsCtxType {
  return useContext(MetricsContext);
}
